import Timer from './timer';
import Item from './item';

const LEVELS = [
    // Level 1
    {
        collectible_lists: 1,
        not_collectible: [],
        used_items: [1, 2, 3, 4, 5, 6],
        speed: 1,
        density: 1,
        time: 40,
    },
    // Level 2
    {
        collectible_lists: 2,
        not_collectible: [],
        used_items: [1, 2, 3, 4, 5, 6],
        speed: 1.05,
        density: 1,
        time: 60,
    },
    // Level 3
    {
        collectible_lists: 3,
        not_collectible: [7],
        used_items: [1, 2, 3, 4, 5, 6, 7],
        speed: 1.1,
        density: 1,
        time: 80,
    },
    // Level 4
    {
        collectible_lists: 1,
        not_collectible: [7, 8],
        used_items: [1, 2, 3, 4, 5, 6, 7, 8],
        speed: 1.15,
        density: 0.85,
        time: 40,
    },
    // Level 5
    {
        collectible_lists: 2,
        not_collectible: [7, 8],
        used_items: [1, 2, 3, 4, 5, 6, 7, 8],
        speed: 1.2,
        density: 0.85,
        time: 60,
    },
    // Level 6
    {
        collectible_lists: 3,
        not_collectible: [7, 8],
        used_items: [1, 2, 3, 4, 5, 6, 7, 8],
        speed: 1.25,
        density: 0.85,
        time: 80,
    },
    // Level 7
    {
        collectible_lists: 2,
        not_collectible: [7, 8],
        used_items: [1, 2, 3, 4, 5, 6, 7, 8],
        speed: 1.3,
        density: 0.85,
        time: 50,
    },
    // Level 8
    {
        collectible_lists: 3,
        not_collectible: [8],
        used_items: [1, 2, 3, 4, 5, 7, 8],
        speed: 1.35,
        density: 0.8,
        time: 70,
    },
    // Level 9
    {
        collectible_lists: 4,
        not_collectible: [7, 8],
        used_items: [1, 2, 3, 4, 5, 7, 8],
        speed: 1.4,
        density: 0.8,
        time: 60,
    },
    // Level 10
    {
        collectible_lists: 4,
        not_collectible: [7, 8],
        used_items: [1, 2, 3, 4, 5, 7, 8],
        speed: 1.45,
        density: 0.7,
        time: 80,
    },
];

const ITEMS = {
    1: 'balloon.png',
    2: 'ball.png',
    3: 'shield.png',
    4: 'hat.png',
    5: 'bear.png',
};

const CHARACTERS = {
    1: 'alvin.png',
    2: 'simon.png',
    3: 'theadore.png',
};

const DROP_INTERVAL = 750;

const SCORE_PER_ROUND = 50;

const SCORE_PER_SECOND = 2;

const LAST_LEVEL = 10;

const LAST_LEVEL_COMPETITION = 1;

const CLOCK_ID = 6;

const ICE_ID = 7;

const PAINT_ID = 8;

const clickSound = 'ClickSound';
const backgroundSound = 'BackgroundSound';

createjs.Sound.registerSound('sounds/click.mp3', clickSound);

createjs.Sound.on('fileload', loadHandler);
createjs.Sound.registerSound('sounds/background.mp3', backgroundSound);

function loadHandler(event) {
    if (event.id === backgroundSound) {
        createjs.Sound.play(backgroundSound, { volume: 0.1, loop: -1 });
    }
}

const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
);

// Sets "font-size" of "<html>" to the width of it, in pixels. All other elements get their dimensions
//relative to this font-size, in rems;
function mobileDimension() {
    document.documentElement.style.width = '100%';
    document.documentElement.style.fontSize =
        document.documentElement.clientWidth;
}

// If mobile, resize elements;
if (window.innerWidth < 562) {
    mobileDimension();
}

export default class Game {
    /**
     * Timer instance.
     */
    static timer;

    /**
     * True if the game has started.
     */
    #gameStarted;

    /**
     * Dropped items count.
     */
    #itemsCount;

    /**
     * Last dropped item id.
     */
    #lastDroppedItemId;

    /**
     * Current character id of the level.
     */
    static currentCharacterId;

    /**
     * Current level running.
     */
    static currentLevel;

    /**
     * Current items order arrays.
     */
    static currentItems;

    /**
     * Current collected items.
     */
    static currentCollected;

    /**
     * Current collected rounds count.
     */
    static currentCollectedRounds;

    /**
     * Current score.
     */
    static currentScore;

    /**
     * Game mode (classic/competition).
     */
    static gameMode;

    /**
     * Last level.
     */
    static lastLevel;

    /**
     * Highest score.
     */
    static highScore;

    /**
     * Drop items interval.
     */
    static dropItemsIntervalInstance;

    /**
     * Game wrapper height.
     */
    static gameHeight;

    /**
     * Game wrapper width.
     */
    static gameWidth;

    /**
     * Suitcase width.
     */
    static suitcaseWidth;

    /**
     * Correct animation timeout.
     */
    static correctAnimationTimeout;

    /**
     * Incorrect animation timeout.
     */
    static incorrectAnimationTimeout;

    /**
     * Splash animation timeout.
     */
    static splashAnimationTimeout;

    /**
     * True if the window is currently focused.
     */
    static windowFocused;

    /**
     * True if the level is running.
     */
    static levelIsRunning;

    /**
     * True if the suitcase is frozen by ice item.
     */
    static suitcaseFrozen;

    constructor(gameMode) {
        this.#itemsCount = 0;
        this.#lastDroppedItemId = 0;

        const level = Game.getUrlParameter('level');

        Game.currentCharacterId = 1;
        Game.timer = new Timer();
        Game.currentLevel = level || 1;
        Game.currentCollectedRounds = 0;
        Game.currentCollected = [];
        Game.currentItems = [];
        Game.currentScore = 0;
        Game.gameMode = gameMode;
        if (gameMode === 'classic') {
            Game.lastLevel = LAST_LEVEL;
        } else {
            Game.lastLevel = LAST_LEVEL_COMPETITION;
        }
        Game.windowFocused = true;
        Game.levelIsRunning = false;
        Game.suitcaseFrozen = false;
        Game.highScore =
            parseInt(window.localStorage.getItem('high_score')) || 0;

        $('.start-game-button').on('click', () => this.startGame());
        mobile
            ? $('.game').on('touchmove', (event) => this.onMouseMove(event))
            : $('.game').on('mousemove', (event) => this.onMouseMove(event));
        $('.play-button').on('click', () => this.startNewLevel());
        $('.try-again-button').on('click', () => this.tryAgain());
        $('.next-level-button').on('click', () => this.nextLevel());
        $('.sound-button').on('click', () => this.toggleSound());
        $(window).focus(() => {
            Game.timer.resumeOnFocus();
            Game.windowFocused = true;
        });
        $(window).blur(() => {
            Game.windowFocused = false;
            Game.timer.pauseOnBlur();
        });
        $(window).on('resize', mobileDimension);

        if (mobile) {
            // on mobile, remove default dragging from certain elements;
            let removeDrag = [document, $('.suitcase')[0], $('.level-ui')[0]];

            removeDrag.forEach((element) => {
                element.addEventListener(
                    'touchmove',
                    function (e) {
                        e.preventDefault();
                    },
                    { passive: false }
                );
            });
        }

        this.showNewLevel();
    }

    /**
     * Method user to hide the splash screen and show the game screen.
     */
    startGame() {
        createjs.Sound.play(clickSound);

        ga('send', 'event', {
            eventCategory: 'Start Game',
            eventAction: 'Games',
            eventLabel: 'Alvin and the Chipmunks',
        });

        $('.splash').addClass('hidden');
        $('.splash-competition').addClass('hidden');
        $('.wrapper').removeClass('hidden');

        Game.gameHeight = $('.game').height();
        Game.gameWidth = $('.game').width();
        Game.suitcaseWidth = $('.game .suitcase').width();
    }

    /**
     * Method used to show the new level info.
     */
    showNewLevel() {
        $('.timer-bar').removeClass('show');
        $('.new-level-ui').addClass('show');
        $('#newLevel').text(Game.currentLevel);
        $('#highScore').text(Game.highScore);
        $('.level-ui').removeClass('show');
        $('.dark-background').addClass('show');

        Game.currentCharacterId = Game.getRandomArbitrary(1, 3);

        Game.currentItems = [];
        for (
            let i = 0;
            i < LEVELS[Game.currentLevel - 1].collectible_lists;
            i++
        ) {
            Game.currentItems.push(Game.shuffleArray([1, 2, 3, 4, 5]));
        }

        Game.generateNewLevelItems();
    }

    /**
     * Method used to start a new level.
     */
    startNewLevel() {
        createjs.Sound.play(clickSound);

        ga('send', 'event', {
            eventCategory: 'Play Level',
            eventAction: 'Games',
            eventLabel: 'Alvin and the Chipmunks',
        });

        $('.timer-bar').addClass('show');
        $('.level-ui').addClass('show');
        $('.dark-background').removeClass('show');
        $('.new-level-ui').removeClass('show');

        Game.generateLevelItems();

        this.#gameStarted = true;
        $('.game').addClass('game-running');

        $('.game .suitcase, .game .suitcase-front').removeClass('hidden');

        // Start dropping items after a slight delay.
        setTimeout(() => {
            Game.levelIsRunning = true;
            this.dropItems();
            // Start the timer of the level.
            Game.timer.start(LEVELS[Game.currentLevel - 1].time);
        }, 500);
    }

    /**
     * Method called on try again button click.
     */
    tryAgain() {
        createjs.Sound.play(clickSound);

        ga('send', 'event', {
            eventCategory: 'Try Again',
            eventAction: 'Games',
            eventLabel: 'Alvin and the Chipmunks',
        });

        Game.currentLevel = 1;
        Game.currentCollectedRounds = 0;
        Game.currentCollected = [];
        Game.currentItems = [];
        Game.currentScore = 0;

        $('#badLuckUi').removeClass('show');
        $('#highScoreUi').removeClass('show');
        $('.current-level').removeClass('hidden');
        $('.current-level-label').text(` ${Game.currentLevel}`);

        this.showNewLevel();
        if (Game.gameMode === 'competition') {
            $('.splash-competition').removeClass('hidden');
            $('.wrapper').addClass('hidden');
        }
    }

    /**
     * Method called on next level button click.
     */
    nextLevel() {
        createjs.Sound.play(clickSound);

        ga('send', 'event', {
            eventCategory: 'Next Level',
            eventAction: 'Games',
            eventLabel: 'Alvin and the Chipmunks',
        });

        if (Game.currentLevel === Game.lastLevel) {
            Game.showEnterCompetitionScreen();
        } else {
            $('#endLevelUi').removeClass('show');

            const newPoints = SCORE_PER_ROUND * Game.currentCollectedRounds;
            const timeBonus = SCORE_PER_SECOND * Game.timer.getCurrentSeconds();
            Game.currentScore += newPoints + timeBonus;

            $('#currentScore').text(Game.currentScore);

            Game.currentLevel++;

            $('.current-level').removeClass('hidden');
            $('.current-level-label').text(` ${Game.currentLevel}`);

            Game.currentCollectedRounds = 0;
            Game.currentCollected = [];
            Game.currentItems = [];

            this.showNewLevel();
        }
    }

    toggleSound() {
        if ($('.sound-button').hasClass('sound-on')) {
            $('.sound-button').removeClass('sound-on').addClass('sound-off');
            createjs.Sound.stop(backgroundSound);
        } else {
            $('.sound-button').removeClass('sound-off').addClass('sound-on');
            createjs.Sound.play(backgroundSound, { volume: 0.1, loop: -1 });
        }
    }

    /**
     * Method used to drop the items in the interval.
     */
    dropItems() {
        Game.dropItemsIntervalInstance = setInterval(() => {
            if (Game.windowFocused) {
                const newItem = this.getNewItem();
                $('.game').append(newItem);
                new Item(
                    'collectible',
                    '#item' + this.#itemsCount,
                    newItem.data('id'),
                    LEVELS[Game.currentLevel - 1].speed
                );
                this.#itemsCount++;
            }
        }, DROP_INTERVAL * LEVELS[Game.currentLevel - 1].density);
    }

    /**
     * Method used to get a new random item.
     */
    getNewItem() {
        const usedItemsLength = LEVELS[Game.currentLevel - 1].used_items.length;
        const item = $('<div class="item"></div>');
        let itemId = Game.getRandomArbitrary(
            LEVELS[Game.currentLevel - 1].used_items[0],
            LEVELS[Game.currentLevel - 1].used_items[usedItemsLength - 1]
        );
        while (
            itemId === this.#lastDroppedItemId ||
            ((itemId === 7 || itemId === 8) &&
                $('.item-7, .item-8').length >= 2)
        ) {
            itemId = Game.getRandomArbitrary(
                LEVELS[Game.currentLevel - 1].used_items[0],
                LEVELS[Game.currentLevel - 1].used_items[usedItemsLength - 1]
            );
        }

        // remove clock item from level 8, 9 and 10;
        while (Game.currentLevel > 7 && itemId === 6) {
            itemId = Game.getRandomArbitrary(
                LEVELS[Game.currentLevel - 1].used_items[0],
                LEVELS[Game.currentLevel - 1].used_items[usedItemsLength - 1]
            );
        }

        this.#lastDroppedItemId = itemId;
        item.addClass('item-' + itemId);
        item.prop('id', 'item' + this.#itemsCount);
        item.data('id', itemId);

        return item;
    }

    /**
     * Methods called on mouse move event and set position of the suitcase.
     *
     * @param {*} event
     */
    onMouseMove(event) {
        // If the game has started.
        if (this.#gameStarted && !Game.suitcaseFrozen) {
            const offset = $(event.currentTarget).offset();
            const width = $('.game .suitcase').width();
            const totalWidth = $('.game').width();
            const x = mobile
                ? event.changedTouches[0].pageX - offset.left
                : event.pageX - offset.left;
            const xOffset = x - width / 2;
            // If the offset is within the game boundaries.
            if (xOffset > 0 && xOffset + width < totalWidth) {
                $('.game .suitcase, .game .suitcase-front').css(
                    'left',
                    x - width / 2
                );
            }
        }
    }

    /**
     * Method used to generate the level items elements.
     */
    static generateLevelItems() {
        $('.level-ui .ui-items-list').html('');
        for (
            let i = 0;
            i < Game.currentItems[Game.currentCollectedRounds].length;
            i++
        ) {
            $('.ui-items-list').append(
                '<div class="ui-item"><img src="img/collect-' +
                    ITEMS[Game.currentItems[Game.currentCollectedRounds][i]] +
                    '" alt="item" class="ui-item-icon"/></div>'
            );
        }
    }

    /**
     * Method used to generate the new level items elements.
     */
    static generateNewLevelItems() {
        $(
            '.new-level-ui .character, .level-ui .character, .end-game-ui .character'
        ).prop('src', 'img/' + CHARACTERS[Game.currentCharacterId]);
        $('.new-level-ui .ui-items-lists').html('');
        for (let i = 0; i < Game.currentItems.length; i++) {
            let newList = $('<div class="ui-items-list"></div>');
            for (let j = 0; j < Game.currentItems[i].length; j++) {
                newList.append(
                    '<div class="ui-item"><img src="img/collect-' +
                        ITEMS[Game.currentItems[i][j]] +
                        '" alt="item" class="ui-item-icon"/></div>'
                );
            }
            $('.new-level-ui .ui-items-lists').append(newList);
        }
        $('.ui-wrong-items-list').addClass('hidden');
        if (LEVELS[Game.currentLevel - 1].not_collectible.length > 0) {
            $('.ui-wrong-items-list').removeClass('hidden');
            if (
                LEVELS[Game.currentLevel - 1].not_collectible.indexOf(
                    ICE_ID
                ) !== -1
            ) {
                $(
                    '.ui-wrong-items-list img[data-id="' + ICE_ID + '"]'
                ).removeClass('hidden');
            }
            if (
                LEVELS[Game.currentLevel - 1].not_collectible.indexOf(
                    PAINT_ID
                ) !== -1
            ) {
                $(
                    '.ui-wrong-items-list img[data-id="' + PAINT_ID + '"]'
                ).removeClass('hidden');
            }
        }
    }

    /**
     * Method used to check if the given element is the right one in the correct position.
     *
     * @param {*} item
     */
    static isTheRightItem(item) {
        return (
            item ===
                Game.currentItems[Game.currentCollectedRounds][
                    Game.currentCollected.length - 1
                ] || item === 6
        );
    }

    /**
     * Method used to check if item is clock.
     */
    static checkClock(item) {
        return item === CLOCK_ID;
    }

    /**
     * Method used to check if the collected are are 5.
     */
    static isTheItemsOrderDone() {
        return Game.currentCollected.length === 5;
    }

    /**
     * Method used to check if the level is completed.
     */
    static isTheLevelDone() {
        return (
            Game.currentCollectedRounds ===
            LEVELS[Game.currentLevel - 1].collectible_lists
        );
    }

    /**
     * Method used to show the end level screen.
     */
    static showEndLevelScreen() {
        ga('send', 'event', {
            eventCategory: 'End Level <' + Game.currentLevel + '>',
            eventAction: 'Games',
            eventLabel: 'Alvin and the Chipmunks',
        });
        $('.game').removeClass('game-running');
        Game.levelIsRunning = false;
        // Stop the timer.
        Game.timer.stop();
        // Clear the drop items interval.
        clearInterval(Game.dropItemsIntervalInstance);
        // Remove remaining items.
        $('.game .item').remove();
        // Prepare and show end level data.
        const newPoints = SCORE_PER_ROUND * Game.currentCollectedRounds;
        const timeBonus = SCORE_PER_SECOND * Game.timer.getCurrentSeconds();
        $('#levelNumber').text(Game.currentLevel);
        $('#currentScoreValue').text(Game.currentScore);
        $('#newPointsValue').text(newPoints);
        $('#timeBonusValue').text(timeBonus);
        $('#totalValue').text(Game.currentScore + newPoints + timeBonus);
        // Show the UI and hide the not needed elements.
        $('#endLevelUi').addClass('show');
        $('.level-ui').removeClass('show');
        $('.dark-background').addClass('show');
        $('.timer-bar').removeClass('show');
        $('.game .suitcase, .game .suitcase-front').addClass('hidden');
        $('.current-level').addClass('hidden');

        if (Game.gameMode === 'competition') {
            Game.showEnterCompetitionScreen();
        }
    }

    /**
     * Method used to show the bad luck screen.
     */
    static showBadLuckScreen() {
        $('.game').removeClass('game-running');
        Game.levelIsRunning = false;
        // Stop the timer.
        Game.timer.stop();
        // Clear the drop items interval.
        clearInterval(Game.dropItemsIntervalInstance);
        // Remove remaining items.
        $('.game .item').remove();
        // Show the UI and hide the not needed elements.
        $('#badLuckUi').addClass('show');
        $('.level-ui').removeClass('show');
        $('.dark-background').addClass('show');
        $('.timer-bar').removeClass('show');
        $('.game .suitcase, .game .suitcase-front').addClass('hidden');
        $('.current-level').addClass('hidden');
    }

    /**
     * Method used to show the high score screen.
     */
    static showHighScoreScreen() {
        $('.game').removeClass('game-running');
        Game.levelIsRunning = false;
        $('#highScoreValue').text(Game.currentScore);
        // Stop the timer.
        Game.timer.stop();
        // Clear the drop items interval.
        clearInterval(Game.dropItemsIntervalInstance);
        // Remove remaining items.
        $('.game .item').remove();
        // Show the UI and hide the not needed elements.
        $('#highScoreUi').addClass('show');
        $('.level-ui').removeClass('show');
        $('.dark-background').addClass('show');
        $('.timer-bar').removeClass('show');
        $('.game .suitcase, .game .suitcase-front').addClass('hidden');
    }

    /**
     * Method used to show the enter competition screen.
     */
    static showEnterCompetitionScreen() {
        $('.game').removeClass('game-running');
        // Show the UI and hide the not needed elements.
        $('#endLevelUi').removeClass('show');
        $('#enterCompetitionUi').addClass('show');
    }

    /**
     * Method used to refresh the collected items
     */
    static refreshCollectedItems() {
        Game.generateLevelItems();
        for (let i = 0; i < Game.currentCollected.length; i++) {
            let src = 'img/collected-' + ITEMS[Game.currentCollected[i]];
            $('.level-ui .ui-items-list .ui-item')
                .eq(i)
                .find('.ui-item-icon')
                .prop('src', src)
                .addClass('collected');
        }
    }

    /**
     * Method used to get a random number in the given interval.
     *
     * @param {*} min
     * @param {*} max
     */
    static getRandomArbitrary(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    /**
     * Method used to shuffle a given array.
     *
     * @param {*} array
     */
    static shuffleArray(array) {
        let currentIndex = array.length,
            temporaryValue,
            randomIndex;

        // While there remain elements to shuffle...
        while (0 !== currentIndex) {
            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }

        return array;
    }

    static getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null
            ? ''
            : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }
}
